<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Partners.defaultCreditInfoSettings')"
    :width="$selectByLang('450px', '450px', '740px')"
    :close-on-click-modal="false"
  >
    <!--默认信控-->
    <div style="border: 1px solid #b5b5b5">
      <div class="credit" :data-content="$t('Partners.maintainDefaultCreditInfo') + '：'">
        <el-form style="margin-top: -20px" :label-width="$selectByLang('90px', '90px', '130px')" label-position="left">
          <el-form-item :label="$t('CargoMsg.Cargo_BranchCMP')">
            <cargo-owned-branch-select
              v-model="form.branchId"
              no="branchId"
              :select-type="selectTypeNames.basic_data_Office_All"
              @change="queryDefaultCreditInfo()"
            />
          </el-form-item>
          <el-form-item :label="$t('Partners.dateType')" class="margin-Right50">
            <el-select v-model="form.remarks" no="remarks">
              <el-option v-for="(item, index) in DATETYPE_TYPE" :key="index" :label="$getLangColumn(item)" :value="item.code" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Invoice.invoice_settlementMethod')">
            <div style="display: flex">
              <el-select v-model="creditDateTypeObj.val1" no="val1">
                <el-option :label="$t('Partners.monthlySettlement')" :value="-1" />
                <el-option :label="$t('CargoMsg.Cargo_SettleByWeekly')" :value="-2" />
                <el-option :label="$t('CargoMsg.Cargo_FixedDateMonthly')" value="n" />
                <el-option :label="$t('Partners.space5')" :value="-3" />
                <el-option :label="$t('Partners.dailySettlement')" :value="-4" />
              </el-select>
              <el-input-number
                v-show="creditDateTypeObj.val1==='n'"
                no="val2"
                :value="creditDateTypeObj.val2||undefined"
                :min="0"
                :precision="0"
                :controls="false"
                @input="val=>{creditDateTypeObj.val2=val}"
              />
            </div>
          </el-form-item>
          <el-form-item :label="$t('Partners.accountPeriod')" class="margin-Right50">
            <div style="display: flex">
              <el-input-number
                v-model="form.creditDateLimited"
                no="creditDateLimited"
                :min="0"
                :precision="0"
                controls-position="right"
                style="width: 300px"
              />
              <el-select v-model="form.termUnit" no="termUnit" style="width: 200px;margin-left: 5px">
                <el-option :label="$t('Partners.day')" :value="0" />
                <el-option :label="$t('Partners.week')" :value="1" />
                <el-option :label="$t('Partners.month')" :value="2" />
              </el-select>
            </div>
          </el-form-item>
          <el-form-item :label="$t('Partners.limit')">
            <div style="display: flex">
              <el-input-number
                v-model="form.credit"
                no="credit"
                :min="0"
                :precision="0"
                :controls="false"
                style="width: 300px"
              />
              <el-select v-model="form.currency" no="currency" style="margin-left:5px;width: 200px">
                <el-option label="RMB" :value="'RMB'" />
                <el-option label="USD" :value="'USD'" />
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label-width="0">
            <span style="color: darkred;">{{ $t('Partners.defaultCreditInfoNote') }}</span>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!--保底信控-->
    <div v-if="baoDiCreditEnable" style="border: 1px solid #b5b5b5;margin-top: 4px">
      <div class="credit" :data-content="$t('CargoMsg.Cargo_BottomLineCreditControl') + '：'">
        <el-form style="margin-top: -20px" :label-width="$selectByLang('90px', '90px', '130px')" label-position="left">
          <el-form-item :label="$t('CargoMsg.Cargo_BranchCMP')">
            <cargo-advance-select
              no="branchId2"
              :select-type="selectTypeNames.basic_data_Office_All"
              :disabled="true"
              :default-value="baoDiForm.branchId||''"
              tag-name="code"
              :placeholder="' '"
            />
          </el-form-item>
          <el-form-item :label="$t('Partners.dateType')" class="margin-Right50">
            <el-select v-model="baoDiForm.remarks" no="remarks2">
              <el-option v-for="(item, index) in DATETYPE_TYPE" :key="index" :label="$getLangColumn(item)" :value="item.code" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Partners.accountPeriod')" class="margin-Right50">
            <div style="display: flex">
              <el-input-number
                v-model="baoDiForm.creditDateLimited"
                no="creditDateLimited2"
                :min="0"
                :precision="0"
                controls-position="right"
                style="width: 300px"
              />
              <el-select v-model="baoDiForm.termUnit" no="termUnit2" style="width: 200px;margin-left: 5px">
                <el-option :label="$t('Partners.day')" :value="0" />
                <el-option :label="$t('Partners.week')" :value="1" />
                <el-option :label="$t('Partners.month')" :value="2" />
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label-width="0">
            <span style="color: darkred;">{{ $t('CargoMsg.Cargo_BaoDiCreditInfoNote') }}</span>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div slot="footer" style="margin: 0 auto;width: fit-content;">
      <el-button type="primary" @click="confirmHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button @click="innerVisible = false">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import {
  getDefaultAndBaoDiCreditInfo,
  getDefaultCreditInfo,
  saveDefaultAndBaoDiCreditInfo,
  saveDefaultCreditInfo
} from '@/api/partner/creditInfo'
import { DATETYPE_TYPE } from '@/class/cargo/model/parameters/ContractConstants'
import CargoOwnedBranchSelect from '@/components/Cargo/Common/CargoOwnedBranchSelect.vue'
import { cache, cacheName } from '@/utils/cacheManager'
import { DEFAULT_CREDIT_TYPE_BAO_DI, DEFAULT_CREDIT_TYPE_DEFAULT } from '@/class/cargo/model/parameters/SystemConstants'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'

export default {
  name: 'DefaultCreditInfoDialog',
  components: { CargoOwnedBranchSelect, cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      DATETYPE_TYPE,
      innerVisible: false,
      baseForm: {
        uuid: '',
        remarks: 'ETD',
        creditDateType: -1,
        creditDateLimited: 0,
        termUnit: 0,
        credit: 0,
        currency: 'RMB',
        type: DEFAULT_CREDIT_TYPE_DEFAULT.code
      },
      form: {
        uuid: '',
        remarks: 'ETD',
        creditDateType: -1,
        creditDateLimited: 0,
        termUnit: 0,
        credit: 0,
        currency: 'RMB',
        branchId: this.$store.getters.currentOfficeId,
        type: DEFAULT_CREDIT_TYPE_DEFAULT.code
      },
      baoDiBaseForm: {
        uuid: '',
        remarks: 'ETD',
        creditDateType: -1,
        creditDateLimited: 0,
        termUnit: 0,
        credit: 0,
        currency: 'RMB',
        type: DEFAULT_CREDIT_TYPE_BAO_DI.code
      },
      baoDiForm: {
        uuid: '',
        remarks: 'ETD',
        creditDateType: -1, // 固定 按月结算
        creditDateLimited: 0,
        termUnit: 0,
        credit: 0,
        currency: 'RMB',
        branchId: 2, // 固定 上海分公司
        type: DEFAULT_CREDIT_TYPE_BAO_DI.code
      },
      creditDateTypeObj: {
        val1: -1,
        val2: 0
      },
      hasUpdate: false,
      dataType: 0,
      dataTypeList: [
        { label: this.$t('CargoMsg.Cargo_Superior'), value: 0 },
        { label: this.$t('CargoMsg.Cargo_OfficeAndDep'), value: 1 }
      ],
      manager: 0,
      defaultOfficeId: 0,
      defaultDepId: 0,
      baoDiCreditEnable: false // 保底信控是否开启
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.initData()
        this.innerVisible = newVal
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        if (this.hasUpdate) {
          this.$emit('callback')
        }
      }
    }
  },
  methods: {
    async initData() {
      await cache.load(cacheName.CONFIG)
      this.baoDiCreditEnable = Number(cache.config.get('baoDiCreditEnable')) === 1
      this.getCreditInfo()
    },
    async confirmHandler() {
      const form = this.form
      const val = this.creditDateTypeObj.val1 !== 'n' ? this.creditDateTypeObj.val1 : this.creditDateTypeObj.val2
      form.creditDateType = val || 0
      const loading = getLoading4Cxt(this)
      if (this.baoDiCreditEnable) {
        await saveDefaultAndBaoDiCreditInfo({ defaultCreditInfo: form, baoDiCreditInfo: this.baoDiForm }).then(res => {
          if (res.ok) {
            this.$message.success(this.$t('Message.SaveSuccessfully'))
          } else {
            this.$message.error(this.$t('Message.SaveFailed'))
          }
        }).finally(() => {
          loading.close()
        })
      } else {
        await saveDefaultCreditInfo(form).then(res => {
          if (res.ok) {
            this.$message.success(this.$t('Message.SaveSuccessfully'))
          } else {
            this.$message.error(this.$t('Message.SaveFailed'))
          }
        }).finally(() => {
          loading.close()
        })
      }
      this.innerVisible = false
    },
    getCreditInfo() {
      if (this.baoDiCreditEnable) {
        getDefaultAndBaoDiCreditInfo({ branchId: this.form.branchId }).then(res => {
          if (res.ok) {
            const data = res.data
            if (data) {
              this.initDefaultCreditInfo(data.defaultCreditInfo)
              this.initBaoDiCreditInfo(data.baoDiCreditInfo)
            }
          }
        })
      } else {
        this.queryDefaultCreditInfo()
      }
    },
    queryDefaultCreditInfo() {
      getDefaultCreditInfo({ branchId: this.form.branchId }).then(res => {
        if (res.ok) {
          const data = res.data
          this.initDefaultCreditInfo(data)
        }
      })
    },
    initDefaultCreditInfo(creditInfo) {
      if (creditInfo && creditInfo.uuid) {
        Object.assign(this.form, creditInfo)
        if (this.form.creditDateType === 0) {
          this.form.creditDateType = -1
        }
        if (this.form.creditDateType === -1 || this.form.creditDateType === -2 || this.form.creditDateType === -3 || this.form.creditDateType === -4) {
          this.creditDateTypeObj.val1 = this.form.creditDateType
        } else {
          this.creditDateTypeObj.val1 = 'n'
          this.creditDateTypeObj.val2 = this.form.creditDateType
        }
      } else {
        Object.assign(this.form, this.baseForm)
        this.creditDateTypeObj.val1 = -1
        this.creditDateTypeObj.val2 = 0
      }
    },
    initBaoDiCreditInfo(creditInfo) {
      if (creditInfo && creditInfo.uuid) {
        Object.assign(this.baoDiForm, creditInfo)
      } else {
        Object.assign(this.baoDiForm, this.baoDiBaseForm)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.credit {
  position: relative;
  padding: 10px;
  border: 22px solid #f2f2f2;
  border-radius: 4px;
}
.credit::before {
  content: attr(data-content);
  position: relative;
  top: -29px;  /* 根据需要调整 */
  left: -8%;
  transform: translateX(-50%);
  background-color: #f2f2f2;
  padding: 0 5px;
  font-size: 16px;
}
</style>
